import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ListItem } from 'material-ui/List';
import SocialPersonAdd from 'material-ui/svg-icons/social/person-add';
import TextField from 'material-ui/TextField';
import { ListItemInput, Button } from '@atoms';
import messages from './messages';

const ListItemText = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
`;

export default class UserCreateListItem extends Component {
  static propTypes = {
    email: PropTypes.string,
    password: PropTypes.string,
    isCreatingUser: PropTypes.bool,
    createUser: PropTypes.func.isRequired,
    updateCreateUserField: PropTypes.func.isRequired,
  };

  static defaultProps = {
    email: null,
    password: null,
    isCreatingUser: false,
  };

  setUsernameField = (evt, newValue) =>
    this.props.updateCreateUserField('username', newValue);

  setEmailField = (evt, newValue) => this.props.updateCreateUserField('email', newValue);

  setPasswordField = (evt, newValue) =>
    this.props.updateCreateUserField('password', newValue);

  renderNestedItems = () => [
    <ListItemInput key="email-input">
      <TextField
        style={{ width: '100%' }}
        type="email"
        value={this.props.email || ''}
        onChange={this.setEmailField}
        hintText={<FormattedMessage {...messages.inputEmail} />}
      />
    </ListItemInput>,
    <ListItemInput key="password-input">
      <TextField
        style={{ width: '100%' }}
        type="password"
        value={this.props.password || ''}
        onChange={this.setPasswordField}
        hintText={<FormattedMessage {...messages.inputPassword} />}
      />
    </ListItemInput>,
    <ListItemInput key="create-button">
      <Button
        onClick={this.props.createUser}
        loading={this.props.isCreatingUser}
        primary
        small
      >
        <FormattedMessage {...messages.inputSubmit} />
      </Button>
    </ListItemInput>,
  ];

  render() {
    return (
      <ListItem
        leftIcon={<SocialPersonAdd />}
        primaryText={
          <ListItemText>
            <FormattedMessage {...messages.primaryText} />
          </ListItemText>
        }
        primaryTogglesNestedList
        nestedItems={this.renderNestedItems()}
        nestedListStyle={{
          marginLeft: '18px',
          marginRight: '4px',
          textAlign: 'center',
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./components/molecules/UserCreateListItem/UserCreateListItem.component.js